var map = {
	"./AdScreeningSubmissionsManagement": [
		1364,
		949
	],
	"./AdScreeningSubmissionsManagement.vue": [
		1364,
		949
	],
	"./BannerManagement": [
		7043,
		811
	],
	"./BannerManagement.vue": [
		7043,
		811
	],
	"./BrainTrainingGamesManagement": [
		7467,
		794
	],
	"./BrainTrainingGamesManagement.vue": [
		7467,
		794
	],
	"./CareInstitutionsManagement": [
		2122,
		907
	],
	"./CareInstitutionsManagement.vue": [
		2122,
		907
	],
	"./Dashboard": [
		253
	],
	"./Dashboard.vue": [
		253
	],
	"./DrugCategoriesManagement": [
		639,
		291
	],
	"./DrugCategoriesManagement.vue": [
		639,
		291
	],
	"./DrugManagement": [
		9767,
		835
	],
	"./DrugManagement.vue": [
		9767,
		835
	],
	"./EmergencyContactManagement": [
		4161,
		660
	],
	"./EmergencyContactManagement.vue": [
		4161,
		660
	],
	"./KnowledgeBaseManagement": [
		8377,
		650
	],
	"./KnowledgeBaseManagement.vue": [
		8377,
		650
	],
	"./KnowledgeCategoriesManagement": [
		3099,
		229
	],
	"./KnowledgeCategoriesManagement.vue": [
		3099,
		229
	],
	"./Layout": [
		5135
	],
	"./Layout.vue": [
		5135
	],
	"./LocationTestPage": [
		6235,
		964
	],
	"./LocationTestPage.vue": [
		6235,
		964
	],
	"./Login": [
		8562
	],
	"./Login.vue": [
		8562
	],
	"./MemberManagement": [
		8907,
		591
	],
	"./MemberManagement.vue": [
		8907,
		591
	],
	"./MemberPointsManagement": [
		7577,
		878
	],
	"./MemberPointsManagement.vue": [
		7577,
		878
	],
	"./MemoryInterviewManagement": [
		3870,
		795
	],
	"./MemoryInterviewManagement.vue": [
		3870,
		795
	],
	"./MenuManagement": [
		8603,
		136
	],
	"./MenuManagement.vue": [
		8603,
		136
	],
	"./PermissionManagement": [
		9680,
		616
	],
	"./PermissionManagement.vue": [
		9680,
		616
	],
	"./PointsRulesConfiguration": [
		4449,
		368
	],
	"./PointsRulesConfiguration.vue": [
		4449,
		368
	],
	"./PrivacySettingsManagement": [
		8998,
		278
	],
	"./PrivacySettingsManagement.vue": [
		8998,
		278
	],
	"./ProductManagement": [
		6351,
		808
	],
	"./ProductManagement.vue": [
		6351,
		808
	],
	"./ProtectionProtocolManagement": [
		8844,
		840
	],
	"./ProtectionProtocolManagement.vue": [
		8844,
		840
	],
	"./PublicWelfareManagement": [
		9816,
		320
	],
	"./PublicWelfareManagement.vue": [
		9816,
		320
	],
	"./ReportRecognition": [
		9308,
		719
	],
	"./ReportRecognition.vue": [
		9308,
		719
	],
	"./RoleManagement": [
		9605,
		541
	],
	"./RoleManagement.vue": [
		9605,
		541
	],
	"./ScienceArticleManagement": [
		5885,
		109
	],
	"./ScienceArticleManagement.vue": [
		5885,
		109
	],
	"./ScienceCategoryManagement": [
		8682,
		679
	],
	"./ScienceCategoryManagement.vue": [
		8682,
		679
	],
	"./ScienceVideoManagement": [
		7883,
		378
	],
	"./ScienceVideoManagement.vue": [
		7883,
		378
	],
	"./ScreeningKnowledgeCategoryManagement": [
		1298,
		741
	],
	"./ScreeningKnowledgeCategoryManagement.vue": [
		1298,
		741
	],
	"./ScreeningKnowledgeManagement": [
		8930,
		453
	],
	"./ScreeningKnowledgeManagement.vue": [
		8930,
		453
	],
	"./ScreeningToolsManagement": [
		7199,
		960
	],
	"./ScreeningToolsManagement.vue": [
		7199,
		960
	],
	"./ServicePageManagement": [
		2318,
		922
	],
	"./ServicePageManagement.vue": [
		2318,
		922
	],
	"./SystemConfig": [
		8018,
		837
	],
	"./SystemConfig.vue": [
		8018,
		837
	],
	"./UserLocationManagement": [
		7785,
		393
	],
	"./UserLocationManagement.vue": [
		7785,
		393
	],
	"./UserManagement": [
		3321,
		548
	],
	"./UserManagement.vue": [
		3321,
		548
	],
	"./VideoManagement": [
		9204,
		892
	],
	"./VideoManagement.vue": [
		9204,
		892
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5121;
module.exports = webpackAsyncContext;